import {Flex, Link, Text} from '@chakra-ui/react'
import {useTranslation} from 'next-i18next'
import React, {useEffect} from 'react'
import {parseCookies} from 'nookies'
import {useCheckoutContext} from 'modules/checkout/hooks'
import {STEPS} from 'modules/checkout/types'
import {GTM_EVENTS} from '_app/utils/dataLayer'
import {ShippingMethodForm} from '../ShippingMethodForm'
import {FirstStepInfo} from './FirstStepInfo'

export const DeliveryOptionCard = ({ data }) => {
  const { t } = useTranslation('checkout')
  const { cartId } = parseCookies()
  const {
    step,
    setStep,
    selectedShippingMethod,
    setShippingValue,
    selectedShowroom,
  } = useCheckoutContext()
  useEffect(() => {
    if (step !== STEPS.DELIVERY || !data) return
    const payload = {
      ecommerce: {
        checkout: {
          actionField: { step: 2 as const },
          cartId,
        },
      },
    }
    GTM_EVENTS.deliveryMethod(payload)
  }, [step, data])
  return (
    <>
      <Flex justifyContent="space-between" alignItems="center">
        <Text fontWeight={600}>
          01. {t('SELECT_DELIVERY_METHOD', { ns: 'common' })}
        </Text>
        {step !== STEPS.DELIVERY && selectedShippingMethod && (
          <>
            <Link
                onClick={() => {
                  setStep(STEPS.DELIVERY)
                  setShippingValue(0)
                }}
                fontWeight={300}
            >
              {t('EDIT', { ns: 'common' })}
            </Link>
            <FirstStepInfo
                selectedShippingMethod={selectedShippingMethod}
                showRoom={selectedShowroom}
            />
          </>
        )}
      </Flex>
      {step === STEPS.DELIVERY && <ShippingMethodForm />}
    </>
  )
}
